import React from 'react'

import { Button, Collapse, Icon, Typography } from 'antd'

import { getMessage } from '../../../../util/IntlMessages'

import './styles.less'

export const ColumnsChange = (props) => {
  const { setColumnsSelected, columnsDynamic, setColumnsDynamic } = props

  function handleColumnClick(column) {
    const updatedDynamicColumns = columnsDynamic.map((targetColumn) =>
      targetColumn.headerName === column.headerName ? { ...targetColumn, active: !targetColumn.active } : targetColumn
    )

    setColumnsDynamic(updatedDynamicColumns)
    updateColumns(updatedDynamicColumns)
  }

  function updateColumns(columns) {
    const activeColumns = columns.filter((column) => column.active)

    const selectedColumns = {}

    const reducedColumns = activeColumns.filter(
      (column) => !selectedColumns[column.field] && (selectedColumns[column.field] = true)
    )

    setColumnsSelected(reducedColumns)
  }

  return (
    <Collapse bordered={false} className="report-columns">
      <Collapse.Panel
        key="1"
        header={
          <Typography.Text className="report-columns__panel-title">{getMessage('columnSelection')}</Typography.Text>
        }
        className="report-columns__panel"
      >
        <>
          <Typography.Text className="report-columns__panel-description">{getMessage('customReport')}</Typography.Text>
          <div className="report-columns__panel-content">
            {columnsDynamic.map((item, index) => (
              <Button
                key={item.field}
                onClick={() => {
                  handleColumnClick(item, index)
                }}
                className={`report-columns__item${item.active ? '--active' : ''}`}
              >
                {item.headerName}
                <Icon type={item.active ? 'eye' : 'eye-invisible'} />
              </Button>
            ))}
          </div>
        </>
      </Collapse.Panel>
    </Collapse>
  )
}
